module.exports = __webpack_public_path__ + "static/img/LOGO.b0403068.png";